module.exports = "<app-payor-date-range-report reportPath=\"CreateTripStatusReport\"  reportName=\"Trip By Status\"  isDateRange=\"true\" multiStatusDropdown=\"true\" showOptions=\"true\" isPost=\"true\" title=\"Trip By Status\"></app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/report-trips/report-trips.component.html
// module id = 2469
// module chunks = 66